/* eslint-disable no-debugger */
/* eslint-disable default-param-last */
import { getConstants } from '../actions/actionType';

export function DAPList(state = {}, action) {
    switch (action.type) {
    case getConstants.GET_ALL_DAP_SUCCESS:
        return {
            type: getConstants.GET_ALL_DAP_SUCCESS,
            list: action.user.data.data,
            pagination: action.user.data.number_of_pages,
        };
    case getConstants.GET_ALL_DAP_FAILURE:
        return {
            type: getConstants.GET_ALL_SUCCESS,
            message: action.message,
        };
    default:
        return state;
    }
}
